import { render, staticRenderFns } from "./goodsOut.vue?vue&type=template&id=13ec20a2&scoped=true&"
import script from "./goodsOut.vue?vue&type=script&lang=js&"
export * from "./goodsOut.vue?vue&type=script&lang=js&"
import style0 from "./goodsOut.vue?vue&type=style&index=0&id=13ec20a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ec20a2",
  null
  
)

export default component.exports